
<div fxLayout="row">
    <div fxFlex="100">
        <div fxLayout="row" fxLayoutAlign="center">
            <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50" class="p-3">
                <div class="bordered px-3 py-2">
                    <div fxLayoutAlign="space-between center">
                        <mat-icon class="text-muted">perm_identity</mat-icon>
                    </div>
                    <h1 class="secondary-font text-center mb-3">Indiquer votre porte monaie electronique</h1>
                    <div class="divider"></div>
                    <div class="pt-3">
                        <p>
                            Votre porte monaie electronique permet de vous transferer l'argent que vous avez gagnez sur notre platforme.
                            Cette procédure est simple et rapide.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <br /><br />
        <div *ngIf="numeroCompte">
            <div fxLayout="row" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                    <mat-form-field class="w-100">
                        <mat-label>N° de Telephone</mat-label>
                        <input readonly matInput  [value]="numeroCompte.numero_compte_phone_number" required>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                    <app-image-paiement [key]="numeroCompte.numero_compte_operateur" ></app-image-paiement>
                </div>
            </div>
            <br>
            <div fxLayout="row" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="20" class="px-3">
                    <div class="text-center">
                        <button mat-raised-button color="primary" type="submit" class="w-100 uppercase" routerLink="/compte-utilisateur/mes-paiements/mon-porte-monaie">
                            Modifier
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

